import { Col, Container, Row } from "react-bootstrap";
import { useLink } from "@/hooks/useLink";
import { useLocale } from "@/hooks/useLocale";
import classes from "./styles.module.scss";
import clsx from "classnames";
import Back from "@/assets/Back.svg";
import { DynamicText } from "@/ui/DynamicText";
import { formatDistanceToNowStrict } from "date-fns";
import { getTeam } from "@/functions/getTeam";
import SocialShare from "@/ui/SocialShare";
import { Heading } from "@/ui/Heading";

export const InsightPageBannerSection = ({ className, item }) => {
  const locale = useLocale();
  const link = useLink();
  const isVideo = "type" in item ? item.type.toLowerCase() === "video" : false;
  const author = getTeam().find((i) => item.author?.toLowerCase().trim() === i.name?.toLowerCase().trim());

  return (
    <div className={clsx(className, classes.banner)}>
      <Container fluid className="mb-4">
        <header className="p-4 p-md-5 bg-light border">
          <Row className={clsx({ "pb-5": isVideo })}>
            <Col xs={12} md={8} className={clsx({ "pb-5": isVideo })}>
              <a className={classes.backlink} href={link("blog")}>
                <Back />
                <DynamicText path={`insight.link.back.${locale}`} className="ms-2" />
              </a>
              <Heading className="me-md-5 mt-3" variant="primary">
                <h1 dangerouslySetInnerHTML={{ __html: item[`title_${locale}`] }} />
              </Heading>
              <i>
                {author && author?.photo && (
                  <a href={link("team.member", author.url_slug)}>
                    <img src={author.photo} alt={author.name} />
                  </a>
                )}
                {`${item.published ? `${formatDistanceToNowStrict(new Date(item.published), "yyyy")} ago ` : ""}`}
                <span>by </span>
                {author ? <a href={link("team.member", author.url_slug)}>{author.name}</a> : item.author}
                <SocialShare className={clsx(classes.share, "mt-4")} />
              </i>
            </Col>
            {!isVideo && (
              <Col xs={12} md={4}>
                <img className={classes.banner__img} src={item.image} alt={item?.image_alt ?? ""} />
              </Col>
            )}
          </Row>
        </header>
      </Container>
    </div>
  );
};
